<form [formGroup]="form" (ngSubmit)="wyslij()">

  <div class="form-group">
    <label for="poprzednieHasloInput" class="label">{{ 'etykieta.haslo-poprzednie' | translate }}</label>
    <input nbInput type="password" formControlName="poprzednieHaslo" fullWidth id="poprzednieHasloInput" placeholder="{{ 'etykieta.haslo-poprzednie' | translate }}">
    <ng-container *ngIf="f.poprzednieHaslo.errors && f.poprzednieHaslo.touched">
      <p class="caption status-danger" *ngIf="f.poprzednieHaslo.errors.required">{{ 'komunikat.blad.pole-wymagane' | translate }}!</p>
      <p class="caption status-danger" *ngIf="f.poprzednieHaslo.errors.incorrectPassword">{{ 'komunikat.blad.haslo-poprzednie-niepoprawne' | translate }}!</p>
    </ng-container>
  </div>

  <div class="form-group">
    <label for="noweHasloInput" class="label">{{ 'etykieta.haslo' | translate }}</label>
    <input nbInput type="password" formControlName="noweHaslo" fullWidth id="noweHasloInput" placeholder="{{ 'etykieta.haslo' | translate }}">
    <ng-container *ngIf="f.noweHaslo.errors && f.noweHaslo.touched">
      <p class="caption status-danger" *ngIf="f.noweHaslo.errors.required">{{ 'komunikat.blad.pole-wymagane' | translate }}!</p>
      <p class="caption status-danger" *ngIf="f.noweHaslo.errors.minlength">
        {{ 'komunikat.blad.haslo-dlugosc-poczatek' | translate }} 6 {{ 'komunikat.blad.haslo-dlugosc-koniec' | translate }}
      </p>
    </ng-container>
  </div>

  <div class="form-group">
    <label for="powtorzoneHasloInput" class="label">{{ 'etykieta.haslo-powtorzenie' | translate }}</label>
    <input nbInput type="password" formControlName="powtorzoneHaslo" fullWidth id="powtorzoneHasloInput" placeholder="{{ 'etykieta.haslo-powtorzenie' | translate }}">
    <ng-container *ngIf="f.powtorzoneHaslo.errors && f.powtorzoneHaslo.touched">
      <p class="caption status-danger" *ngIf="f.powtorzoneHaslo.errors.required">{{ 'komunikat.blad.pole-wymagane' | translate }}!</p>
      <p class="caption status-danger" *ngIf="f.powtorzoneHaslo.errors.compare">{{ 'komunikat.blad.hasla-roznia-sie' | translate }}!</p>
    </ng-container>
  </div>

  <button nbButton type="submit" status="danger">{{ 'akcja.wyslij' | translate }}</button>
</form>